import React from 'react';

export const StartThread: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'>
    <path
      fill='var(--primary-accent)'
      fillRule='evenodd'
      d='M2.667 3a.667.667 0 000 1.333h10.666a.667.667 0 100-1.333H2.667zM2 8c0-.368.298-.667.667-.667h6a.667.667 0 010 1.334h-6A.667.667 0 012 8zm4.667 4.333c0-.368.298-.666.666-.666h6a.667.667 0 010 1.333h-6a.667.667 0 01-.666-.667z'
      clipRule='evenodd'
    ></path>
  </svg>
);
